import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { API_KIT_COLETA } from "app/auth/baseKitColeta";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openToast } from "app/store/trackingApp/toastSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

export const getTransportadoras = createAsyncThunk(
  "transportadorasApp/transportadoras/getTransportadoras",
  async (data: object, { dispatch, rejectWithValue }) => {
    dispatch(openLoading());

    let responseTransportadoras;
    let responseApelidos;
    let responseDiretoriosKitColeta;

    try {
      try {
        responseTransportadoras = await API.get("/transportadoras", {
          params: data,
        });
      } catch (err: any) {
        dispatch(
          openModalError({
            title: "Não foi possível buscar as transportadoras!",
            text: "Se certifique que os dados digitados estão corretos",
            btnLabel: "Voltar",
          })
        );
        console.error(err);
        return rejectWithValue(err?.data);
      }

      try {
        responseApelidos = await API_KIT_COLETA.get("/diretorios/apelidos");
      } catch (err: any) {
        console.error(err);
      }

      try {
        responseDiretoriosKitColeta = await API_KIT_COLETA.get("/diretorios");
      } catch (err: any) {
        console.error(err);
      }

      return {
        responseTransportadoras: responseTransportadoras.data,
        responseApelidos: responseApelidos?.data,
        responseDiretoriosKitColeta: responseDiretoriosKitColeta?.data,
      };
    } finally {
      dispatch(closeLoading());
    }
  }
);

export const saveTransportadora = createAsyncThunk(
  "transportadorasApp/transportadoras/saveTransportadora",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.post("/transportadoras", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Transportadora cadastrada",
        })
      );
      dispatch(
        getTransportadoras(
          requestGetParams.transportadorasApp.transportadoras.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível cadastrar a transportadora!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);

export const editTransportadora = createAsyncThunk(
  "transportadorasApp/transportadoras/editTransportadora",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.put("/transportadoras", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Transportadora editada",
        })
      );
      dispatch(
        getTransportadoras(
          requestGetParams.transportadorasApp.transportadoras.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível editar a transportadora!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);

export const deleteTransportadora = createAsyncThunk(
  "transportadorasApp/transportadoras/deleteTransportadora",
  async (data: any, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    const { idCnpjTransportadora } = data;
    try {
      await API.delete(`/transportadoras/${idCnpjTransportadora}`);
      dispatch(
        openToast({
          severity: "success",
          title: "Transportadora removida",
        })
      );
      dispatch(
        getTransportadoras(
          requestGetParams.transportadorasApp.transportadoras.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível remover a transportadora!",
          text: "Se certifique que a solicitação está correta",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);
